import MetalABImage from "@/images/metal_ab@2x.png";
import MetalACImage from "@/images/metal_ac@2x.png";
import MetalAHImage from "@/images/metal_ah@2x.png";
import MetalAVImage from "@/images/metal_av@2x.png";
import MetalAWImage from "@/images/metal_aw@2x.png";
import MetalAXImage from "@/images/metal_ax@2x.png";

export default [
  {
    shape: "方框",
    name: "週歲生日獎牌",
    code: "AB",
    imagePath: MetalABImage,
    accessory: [5],
    way: ["E"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 13,
        maxFontsize: 20,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 30,
      },
      gift: {
        lineLimit: 1,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "方框",
    name: "結婚 祝壽 記念金牌",
    code: "AC",
    imagePath: MetalACImage,
    accessory: [5],
    way: ["E"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 13,
        maxFontsize: 20,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 1,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "方框",
    name: "四方福聚",
    code: "AH",
    imagePath: MetalAHImage,
    accessory: [5],
    way: ["E"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 9,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "方框",
    name: "紀念車牌",
    code: "AV",
    imagePath: MetalAVImage,
    accessory: [5],
    way: ["I"],
    textSetting: {
      commemorativeLicensePlateNumber: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 80,
      },
      commemorativeLicensePlateImageText: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 35,
      },
      commemorativeLicensePlateImageCustom: {
        textLimit: 20,
      },
      commemorativeLicensePlateReverseText: {
        textLimit: 20,
      },
    },
    engravingContentType: "commemorative_license_plate",
  },
  {
    shape: "方框",
    name: "紀念門牌",
    code: "AW",
    imagePath: MetalAWImage,
    accessory: [5],
    way: ["J"],
    textSetting: {
      commemorativeDoorplateImageCustom: { textLimit: 20 },
      commemorativeDoorplateDistrict: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 36,
      },
      commemorativeDoorplateRoadName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 36,
      },
      commemorativeDoorplateHouseNumber: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 90,
      },
      commemorativeDoorplateReverseText: {
        textLimit: 20,
      },
    },
    engravingContentType: "commemorative_doorplate",
  },
  {
    shape: "方框",
    name: "紀念獎牌",
    code: "AX",
    imagePath: MetalAXImage,
    accessory: [5],
    way: ["J"],
    textSetting: {
      commemorativeMedalGreetingsAndName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 36,
      },
      commemorativeMedalGreetingMessage: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 60,
      },
      commemorativeMedalGreetingImageCustom: {
        textLimit: 20,
      },
      commemorativeMedalSenderName: {
        lineLimit: 2,
        textLimit: 14,
        maxFontsize: 24,
      },
    },
    engravingContentType: "commemorative_medal",
  },
];
